import { ITableInputWidget } from '../ITableInputWidget';
import { ITableRow } from '../ITableRow';

// TODO Rimuovere `rowIndex` e mettere `row.id`
export function materializeTableWidgetRowPrefix(
  table: ITableInputWidget,
  row: ITableRow,
  rowIndex: number,
) {
  return `${table.code}_${row.code ?? rowIndex}`;
}
